import React from 'react'
import gifImage from '../../Assets/Error/Animation.gif'
import lottieJson from '../../Assets/Json/Lottie.json'
import Lottie from "lottie-react";
import { Button, ConfigProvider, Modal } from 'antd';
import {
  FilterOutlined,
   } from "@ant-design/icons";
import { useSelector } from 'react-redux';
 
// const NotAuthenticated = ({open,setOpen,isdarkMode,screen}) => {
//   const color = useSelector((state) => state.ThemeChange);
//   // console.log(color)
//   return (
//     <div className="flex flex-col items-center m-0 justify-center h-[80vh] w-[100%] overflow-hidden rounded-xl" 
//     // style={{ backgroundColor: color.themeConfig.colorPrimaryShade }}
//     >
//     {/* <img src={gifImage} alt="Animated GIF" width="300" /> */}
//     <div className=' flex justify-center items-center flex-col gap-2'>
    
//             <Lottie className='w-[300px] h-[300px] overflow-hidden' animationData={lottieJson} loop={true} autoplay={true}  />
      
//       <div className={`${isdarkMode? 'text-white': 'text-black'} font-[Poppins] text-[16px]`}>
//         Contact  <span  className='font-bold'>
//           "Admin"
//           </span>   
//            You are  not allowed to access {screen}
//       </div>

//                <Button type="primary" size="large" className="flex justify-center items-center " onClick={()=>setOpen(!open)}>
//                <FilterOutlined /> Filter
//                </Button>
//     </div>
//   </div>
//   ) 
// }
const NotAuthenticated = ({ open, setOpen, isdarkMode, screen }) => {
  const color = useSelector((state) => state.ThemeChange);

  return (
    <Modal
      open={!open}
      onCancel={() => setOpen(false)}
      footer={null}
      // centered

  mask={false} 
    wrapClassName="custom-modal-wrapper-default"
        className="rounded-xl md:left-96 top-48"
      bodyStyle={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "16px",
        background: isdarkMode ? "#1f1f1f" : "#fff",
        textAlign: "center",
      }}
 closable={false}
   maskClosable={false} 
       >
      {/* Lottie Animation */}
      <Lottie
        className="w-[250px] h-[250px] overflow-hidden"
        animationData={lottieJson}
        loop={true}
        autoplay={true}
      />

      {/* Message */}
      <div
        className={`${
          isdarkMode ? "text-white" : "text-black"
        } font-[Poppins] text-[16px] my-4`}
      >
        Contact <span className="font-bold">"Admin"</span>, You are not allowed
        to access <span className="font-semibold">{screen}</span>
      </div>

      {/* Action Button */}
      {/* <Button
        type="primary"
        size="large"
        className="flex justify-center items-center rounded-lg"
        onClick={() => setOpen(false)}
        style={{
          background: color.themeConfig?.colorPrimaryShade,
          borderColor: color.themeConfig?.colorPrimaryShade,
        }}
      >
        <FilterOutlined /> Close
      </Button> */}
    </Modal>
  );
};

export default NotAuthenticated
